import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IWorkOrderSetting,
  IWorkOrderSettingRow,
} from '../../../../view/settings/api-automation-settings/work-order-settings/work-order-settings.model';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderSettingService {
  private readonly WORK_ORDER_SETTINGS_URL = `${this.baseUrl}/api-automation/work-order-settings`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IWorkOrderSetting>> {
    return this.http.get<GetManyResponseInterface<IWorkOrderSetting>>(this.WORK_ORDER_SETTINGS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IWorkOrderSetting>> {
    return this.http.get<BaseOneResponseInterface<IWorkOrderSetting>>(`${this.WORK_ORDER_SETTINGS_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: IWorkOrderSettingRow): Observable<BaseOneResponseInterface<IWorkOrderSetting>> {
    return this.http.post<BaseOneResponseInterface<IWorkOrderSetting>>(this.WORK_ORDER_SETTINGS_URL, record);
  }

  public editOne(
    recordId: number,
    record: IWorkOrderSettingRow,
  ): Observable<BaseOneResponseInterface<IWorkOrderSetting>> {
    return this.http.patch<BaseOneResponseInterface<IWorkOrderSetting>>(
      `${this.WORK_ORDER_SETTINGS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          workOrderSettings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.WORK_ORDER_SETTINGS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.WORK_ORDER_SETTINGS_URL}/${recordIds[0]}`);
  }
}
